import { combineReducers } from "redux";
import getSaveDataReducer from "./saveDataReducer";
import getSaveResultReducer from "./saveResultReducer";

const saveDataReducer = combineReducers({
    saveData: getSaveDataReducer,
    saveResult: getSaveResultReducer
});

export default saveDataReducer;